enum VaultTypeEnum {
  Password = 0,
  CreditCard = 1,
  SecureNote = 2
}

export default VaultTypeEnum;
